import script from "./BuyWithConfidencePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyWithConfidencePage.vue?vue&type=script&setup=true&lang=ts"

import "./BuyWithConfidencePage.vue?vue&type=style&index=0&id=7a0d9601&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0d9601"]])

export default __exports__